import { useEffect } from 'react'
import debounce from 'lodash/debounce'
import { useSelector } from 'react-redux'
import { config } from '@config/config'
import { authTokenReadySelector, loggingOutSelector, sessionExpiredSelector } from '@redux/slices/connectorSlice'
import { useInsurerConfiguration } from './useInsurerConfiguration'
import { useEnvironment } from './useEnvironment'

/**
 * Fetch initial configuration once session is ready
 */
export const useInitialConfiguration = () => {
  const { brand } = useEnvironment()
  const isTokenReady = useSelector(authTokenReadySelector)
  const isLoggingOut = useSelector(loggingOutSelector)
  const isSessionExpired = useSelector(sessionExpiredSelector)

  const isReady = isTokenReady && !isLoggingOut && !isSessionExpired

  // NOTE: skip unless brand is initialized
  // we can remove this check once the insurerDetails API is also migrated to use api keys
  const { insurers, fetchInsurerConfiguration } = useInsurerConfiguration(!brand)

  useEffect(() => {
    if (insurers?.[0]?.id && isReady && !config.getFeatures().disableInsurerConfigurationInitialFetch) {
      const debouncedHandler = debounce(() => {
        fetchInsurerConfiguration(insurers[0].id)
      })

      debouncedHandler()
      return () => debouncedHandler.cancel()
    }
  }, [fetchInsurerConfiguration, insurers, isReady])
}
